import Vue from 'vue'
import VueRouter from 'vue-router'
import personalInfo from '../pages/personalcenter/children/personalInfo/index'

const systemMaintenance = r => require.ensure([], () => r(require('../pages/systemMaintenance/systemMaintenance')), 'systemMaintenance')
const first = r => require.ensure([], () => r(require('../pages/first')), 'first')
const second = r => require.ensure([], () => r(require('../pages/second')), 'second')
const third = r => require.ensure([], () => r(require('../pages/third')), 'third')


const onlinecard = r => require.ensure([], () => r(require('../pages/onlinecard/index')), 'onlinecard')
const writePersonInfo = r => require.ensure([], () => r(require('../pages/onlinecard/children/writePersonInfo')), 'writePersonInfo')
const uploadCertPhoto = r => require.ensure([], () => r(require('../pages/onlinecard/children/uploadCertPhoto')), 'uploadCertPhoto')
const payDeposit = r => require.ensure([], () => r(require('../pages/onlinecard/children/payDeposit')), 'payDeposit')
const orderPaySuccess = r => require.ensure([], () => r(require('../pages/onlinecard/children/orderPaySuccess')), 'orderPaySuccess')
const noUploadPhoto = r => require.ensure([], () => r(require('../pages/onlinecard/children/noUploadPhoto')), 'noUploadPhoto')
const onlinecardNotice = r => require.ensure([], () => r(require('../pages/onlinecard/children/onlinecardNotice')), 'onlinecardNotice')

const pointcity = r => require.ensure([], () => r(require('../pages/pointcity/index')), 'pointcity')
const myExchange = r => require.ensure([], () => r(require('../pages/pointcity/children/myExchange/index')), 'myExchange')
const integralRule = r => require.ensure([], () => r(require('../pages/pointcity/children/integralRule/index')), 'integralRule')
const integralDetail = r => require.ensure([], () => r(require('../pages/pointcity/children/integralDetail/index')), 'integralDetail')
const taskCenter = r => require.ensure([], () => r(require('../pages/pointcity/children/taskCenter/index')), 'taskCenter')
const prizePage = r => require.ensure([], () => r(require('../pages/pointcity/children/prizePage/index')), 'prizePage')
const prizeDetail = r => require.ensure([], () => r(require('../pages/pointcity/children/prizePage/index')), 'prizeDetail')
const exchangeSuccess = r => require.ensure([], () => r(require('../pages/pointcity/children/prizePage/children/exchangeSuccess')), 'exchangeSuccess')
const exchangeOrder = r => require.ensure([], () => r(require('../pages/pointcity/children/prizePage/children/exchangeOrder')), 'exchangeOrder')

const bookcity = r => require.ensure([], () => r(require('../pages/bookcity/index')), 'bookcity')
const bookPage = r => require.ensure([], () => r(require('../pages/bookcity/children/bookPage/index')), 'bookPage')
const bookOrder = r => require.ensure([], () => r(require('../pages/bookcity/children/bookPage/children/bookOrder')), 'bookOrder')
const bookOrderSuccess = r => require.ensure([], () => r(require('../pages/bookcity/children/bookPage/children/bookOrderSuccess')), 'bookOrderSuccess')
const rankList = r => require.ensure([], () => r(require('../pages/bookcity/children/rankList/index')), 'rankList')
const subjectBookList = r => require.ensure([], () => r(require('../pages/bookcity/children/subjectBookList/index')), 'subjectBookList')
const catagray = r => require.ensure([], () => r(require('../pages/bookcity/children/catagray/index')), 'catagray')
const catagrayBookList = r => require.ensure([], () => r(require('../pages/bookcity/children/catagray/children/catagrayBookList')), 'catagrayBookList')
const messageDetail = r => require.ensure([], () => r(require('../pages/bookcity/children/message/children/messageDetail')), 'messageDetail')
const chooseBookNum = r => require.ensure([], () => r(require('../pages/bookcity/children/bookPage/children/chooseBookNum')), 'chooseBookNum')

const personalcenter = r => require.ensure([], () => r(require('../pages/personalcenter/index')), 'personalcenter')
const changeNick = r => require.ensure([], () => r(require('../pages/personalcenter/children/personalInfo/children/changeNick')), 'changeNick')
const changePhone = r => require.ensure([], () => r(require('../pages/personalcenter/children/personalInfo/children/changePhone')), 'changePhone')
const updatePhone = r => require.ensure([], () => r(require('../pages/personalcenter/children/personalInfo/children/updatePhone')), 'updatePhone')
const myReadCard = r => require.ensure([], () => r(require('../pages/personalcenter/children/myReadCard/index')), 'myReadCard')
const myBorrow = r => require.ensure([], () => r(require('../pages/personalcenter/children/myBorrow/index')), 'myBorrow')
const logisticalInfo = r => require.ensure([], () => r(require('../pages/personalcenter/children/myBorrow/children/logisticalInfo')), 'logisticalInfo')
const orderDetails = r => require.ensure([], () => r(require('../pages/personalcenter/children/myBorrow/children/orderDetails')), 'orderDetails')
const myBookcase = r => require.ensure([], () => r(require('../pages/personalcenter/children/myBookcase/index')), 'myBookcase')
const myAddress = r => require.ensure([], () => r(require('../pages/personalcenter/children/myAddress/index')), 'myAddress')
const addNewAddress = r => require.ensure([], () => r(require('../pages/personalcenter/children/myAddress/children/addNewAddress')), 'addNewAddress')
const editorAddress = r => require.ensure([], () => r(require('../pages/personalcenter/children/myAddress/children/editorAddress')), 'editorAddress')
const readerHelp = r => require.ensure([], () => r(require('../pages/personalcenter/children/readerHelp/index')), 'readerHelp')
const oftenQuestion = r => require.ensure([], () => r(require('../pages/personalcenter/children/readerHelp/children/oftenQuestion')), 'oftenQuestion')
const onlineCardSet = r => require.ensure([], () => r(require('../pages/personalcenter/children/readerHelp/children/onlineCardSet')), 'onlineCardSet')
const onlineService = r => require.ensure([], () => r(require('../pages/personalcenter/children/readerHelp/children/onlineService')), 'onlineService')
const message = r => require.ensure([], () => r(require('../pages/personalcenter/children/message/index')), 'message')

const selecterAddress = r => require.ensure([], () => r(require('../pages/bookcity/children/bookPage/children/selecterAddress')), 'selecterAddress')

const searchWrap = r => require.ensure([], () => r(require('../pages/search/searchWrap')), 'searchWrap')
const search = r => require.ensure([], () => r(require('../pages/search/children/index')), 'search')
const searchResult = r => require.ensure([], () => r(require('../pages/search/children/searchResult')), 'searchresult')

const bindingCard = r => require.ensure([], () => r(require('../pages/bindingCard/bindingCard')), 'bindingCard')

const lackBook = r => require.ensure([], () => r(require('../pages/search/children/lackBook')), 'lackBook')
const lackBookHistory = r => require.ensure([], () => r(require('../pages/search/children/lackBookHistory')), 'lackBookHistory')

const validatePhone = r => require.ensure([], () => r(require('../pages/signin/validatePhone')), 'validatePhone')
const signupSetPassword = r => require.ensure([], () => r(require('../pages/signin/signupSetPassword')), 'signupSetPassword')
const changePassword = r => require.ensure([], () => r(require('../pages/signin/changePassword')), 'changePassword')
const login = r => require.ensure([], () => r(require('../pages/signin/login')), 'login')
const userAgreement = r => require.ensure([], () => r(require('../pages/signin/userAgreement')), 'userAgreement')
const index = r => require.ensure([], () => r(require('../pages/index')), 'index')

Vue.use(VueRouter)

const router = [{
    path: '/',
    component: first,
    children: [{
        path: '',
        component: bookcity
    }, {
        path: 'onlinecard',
        component: onlinecard
    }, {
        path: 'pointcity',
        component: pointcity
    }, {
        path: 'personalcenter',
        component: personalcenter,
    }]
}, {
    path: 'second',
    component: second,
    children: [{
        path: '/onlinecard/writePersonInfo',
        component: writePersonInfo
    }, {
        path: '/onlinecard/onlinecardNotice',
        component: onlinecardNotice
    }, {
        path: '/onlinecard/uploadCertPhoto',
        component: uploadCertPhoto
    }, {
        path: '/onlinecard/payDeposit/',
        component: payDeposit
    }, {
        path: '/onlinecard/orderPaySuccess/:statu_id',
        component: orderPaySuccess
    }, {
        path: '/onlinecard/noUploadPhoto/:error_id',
        component: noUploadPhoto
    }, {
        path: '/personalcenter/personalinfo',
        component: personalInfo
    }, {
        path: '/personalcenter/personalinfo/changenick',
        component: changeNick
    }, {
        path: '/personalcenter/personalinfo/changephone',
        component: changePhone
    }, {
        path: '/personalcenter/personalinfo/updatephone/:type',
        component: updatePhone
    }, {
        path: '/personalcenter/myreadcard',
        component: myReadCard
    }, {
        path: '/personalcenter/myborrow',
        component: myBorrow
    }, {
        path: '/personalcenter/myborrow/logisticalinfo/:expressorder_id',
        component: logisticalInfo
    }, {
        path: '/personalcenter/myborrow/orderDetails/:borroworder_id',
        component: orderDetails
    }, {
        path: '/personalcenter/mybookcase',
        component: myBookcase
    }, {
        path: '/personalcenter/myaddress/addnewaddress',
        component: addNewAddress
    }, {
        path: '/personalcenter/myaddress/editoraddress/:id',
        component: editorAddress
    }, {
        path: '/personalcenter/readerhelp',
        component: readerHelp
    }, {
        path: '/personalcenter/readerhelp/oftenquestion',
        component: oftenQuestion
    }, {
        path: '/personalcenter/readerhelp/onlinecardset',
        component: onlineCardSet
    }, {
        path: '/personalcenter/readerhelp/onlineservice',
        component: onlineService
    }, {
        path: '/personalcenter/message',
        component: message
    }, {
        path: '/pointcity/myexchange',
        component: myExchange
    }, {
        path: '/pointcity/integralrule',
        component: integralRule
    }, {
        path: '/pointcity/taskcenter',
        component: taskCenter
    }, {
        path: '/pointcity/integraldetail',
        component: integralDetail
    }, {
        path: '/pointcity/prizepage/:id',
        component: prizePage
    }, {
        path: '/pointcity/integraldetail',
        component: integralDetail
    }, {
        path: '/prizepage/exchangesuccess/:id',
        component: exchangeSuccess
    }, {
        path: '/prizepage/:address_id/exchangeorder/:id',
        component: exchangeOrder
    }, {
        path: '/bookcity/bookpage/:book_id/bookorder/:address_id',
        component: bookOrder
    }, {
        path: '/bookcity/bookpage/:book_id/bookordersuccess/:order_id',
        component: bookOrderSuccess
    }, {
        path: '/bookcity/bookpage/:book_id/chooseBookNum',
        component: chooseBookNum
    }, {
        path: '/bookcity/ranklist/:code',
        component: rankList
    }, {
        path: '/bookcity/subjectbooklist/:subject_id',
        component: subjectBookList
    }, {
        path: '/bookcity/catagray',
        component: catagray
    }, {
        path: '/bookcity/catagray/catagraybooklist/:clc_code',
        component: catagrayBookList
    }, {
        path: '/bookcity/message/messagedetail/:article_id',
        component: messageDetail
    }, {
        path: '/bindingcard/bindingcard/:id',
        component: bindingCard
    }, {
        path: '/lackbook',
        component: lackBook
    }, {
        path: '/lackbookhistory',
        component: lackBookHistory
    }, {
        path: '/login',
        component: login
    }, {
        path: '/validatephone/:type',
        component: validatePhone
    }, {
        path: '/signupsetpassword',
        component: signupSetPassword
    }, {
        path: '/changepassword',
        component: changePassword
    }]
}, {
    path: 'third',
    component: third,
    children: [{
        path: '/bookcity/bookpage/:book_id',
        component: bookPage
    }, {
        path: '/personalcenter/myaddress',
        component: myAddress
    }]
}, {
    path: "/search",
    component: searchWrap,
    children: [{
        name: 'search',
        path: '',
        component: search
    }, {
        name: 'searchResult',
        path: 'searchresult/:keyWord',
        component: searchResult
    }]
}, {
    path: "/selecteraddress/:order_type/:goods_id",
    component: selecterAddress
}, {
    path: '/systemMaintenance',
    component: systemMaintenance
}, {
    path: '/useragreement',
    component: userAgreement
}, {
    path: '/index',
    component: index
}]

export default new VueRouter({
    routes: router,
    mode: 'hash'
})


// WEBPACK FOOTER //
// ./src/router/index.js